module.exports = __webpack_public_path__ + "img/horizontal_7_6_8019.dcf1f9f5.png";